import { useOutletContext } from "react-router-dom";
import { OutletIProps } from "../../../../components/sitebase/Base.types";
import { transform } from 'ol/proj';
import { ButtonGroupRanking } from "../../../efas/feedbacks/FeedbackForm";
import { useRef } from "react";
import { toast } from "react-toastify";

export default function ReportMissedEventForm(props: { feature: import("ol/Feature").default<import("ol/geom/Geometry").default>, closeForm: () => void }) {
    console.log(props.feature);
    const coordinates = props.feature.getGeometry()?.getCoordinates();
    const coordinates4326 = transform(coordinates, 'EPSG:3857', 'EPSG:4326')
    const context = useOutletContext<OutletIProps>();
    const selectedRef = useRef<HTMLInputElement>(null);

    const fromDateRef = useRef<HTMLInputElement>(null);
    const toDateRef = useRef<HTMLInputElement>(null);
    const peakDateRef = useRef<HTMLInputElement>(null);

    const countriesList = [
        { fullname: "Albania", abbreviation: "AL" },
        { fullname: "Andorra", abbreviation: "AD" },
        { fullname: "Austria", abbreviation: "AT" },
        { fullname: "Åland Islands", abbreviation: "AX" },
        { fullname: "Belarus", abbreviation: "BY" },
        { fullname: "Belgium", abbreviation: "BE" },
        { fullname: "Bosnia and Herzegovina", abbreviation: "BA" },
        { fullname: "Bulgaria", abbreviation: "BG" },
        { fullname: "Croatia", abbreviation: "HR" },
        { fullname: "Cyprus", abbreviation: "CY" },
        { fullname: "Czechia", abbreviation: "CZ" },
        { fullname: "Denmark", abbreviation: "DK" },
        { fullname: "Estonia", abbreviation: "EE" },
        { fullname: "Faroe Islands", abbreviation: "FO" },
        { fullname: "Finland", abbreviation: "FI" },
        { fullname: "France", abbreviation: "FR" },
        { fullname: "Germany", abbreviation: "DE" },
        { fullname: "Gibraltar", abbreviation: "GI" },
        { fullname: "Greece", abbreviation: "GR" },
        { fullname: "Guernsey", abbreviation: "GG" },
        { fullname: "Hungary", abbreviation: "HU" },
        { fullname: "Iceland", abbreviation: "IS" },
        { fullname: "Ireland", abbreviation: "IE" },
        { fullname: "Isle of Man", abbreviation: "IM" },
        { fullname: "Italy", abbreviation: "IT" },
        { fullname: "Jersey", abbreviation: "JE" },
        { fullname: "Kosovo", abbreviation: "XK" },
        { fullname: "Latvia", abbreviation: "LV" },
        { fullname: "Liechtenstein", abbreviation: "LI" },
        { fullname: "Lithuania", abbreviation: "LT" },
        { fullname: "Luxembourg", abbreviation: "LU" },
        { fullname: "Malta", abbreviation: "MT" },
        { fullname: "Moldova", abbreviation: "MD" },
        { fullname: "Monaco", abbreviation: "MC" },
        { fullname: "Montenegro", abbreviation: "ME" },
        { fullname: "Netherlands", abbreviation: "NL" },
        { fullname: "North Macedonia", abbreviation: "MK" },
        { fullname: "Norway", abbreviation: "NO" },
        { fullname: "Poland", abbreviation: "PL" },
        { fullname: "Portugal", abbreviation: "PT" },
        { fullname: "Romania", abbreviation: "RO" },
        { fullname: "Russia", abbreviation: "RU" },
        { fullname: "San Marino", abbreviation: "SM" },
        { fullname: "Serbia", abbreviation: "RS" },
        { fullname: "Slovakia", abbreviation: "SK" },
        { fullname: "Slovenia", abbreviation: "SI" },
        { fullname: "Spain", abbreviation: "ES" },
        { fullname: "Sweden", abbreviation: "SE" },
        { fullname: "Switzerland", abbreviation: "CH" },
        { fullname: "Svalbard and Jan Mayen", abbreviation: "SJ" },
        { fullname: "Turkey", abbreviation: "TR" },
        { fullname: "Ukraine", abbreviation: "UA" },
        { fullname: "United Kingdom", abbreviation: "GB" },
        { fullname: "Vatican City", abbreviation: "VA" }
    ];

    return <div className="overflow-y-scroll fs-8" style={{ maxHeight: "67vh" }}>
        <div>
            <div className="fs-6">When did the flood event take place (i.e. when exceeded the discharge the 5-year return period)?</div>
            <form className="form"
                onSubmit={(e) => {
                    e.preventDefault();
                    // data["causes"] = {};
                    const formData = new FormData(e.currentTarget);
                    const formProps = Object.fromEntries(formData);
                    formProps["user"] = context.user?.username;
                    const causes = Object.entries(formProps).filter(([key, _]) => key.startsWith("causes-"));

                    if (selectedRef.current && causes.length === 0) {
                        selectedRef.current?.setCustomValidity("Please select at least one cause");
                        selectedRef.current?.reportValidity();
                        return;
                    }
                    // convert flood-type-1,2,3,4 to flood_type array
                    const floodTypeArray: Array<number> = [];
                    for (let i = 1; i <= 4; i++) {
                        const key = `flood-event-${i}`;
                        if (formProps[key]) {
                            floodTypeArray.push(i);
                            delete formProps[key];
                        }
                    }

                    // add flood_type and flood_cause to formProps
                    formProps["flood_type"] = floodTypeArray;
                    const floodCause: { [a: number]: number } = {};
                    causes.forEach((val, index) => {
                        const cause = parseInt(val[0].split("-")[1]);
                        console.debug("Appending cause:", cause);
                        floodCause[index] = cause;
                    });
                    formProps["flood_causes"] = floodCause;

                    // add coordinates
                    formProps["location"] = `POINT (${coordinates4326[0]} ${coordinates4326[1]})`

                    console.log("Submitted missed event report:", formProps, causes);

                    fetch('/api/missed-events/missed-events/?format=json', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify(formProps),
                    }).then(response => {
                        if (response.ok) {
                            console.log("Missed event report submitted successfully.");
                            toast.success("Thank you for your report! It has been submitted.");
                            setTimeout(() => props.closeForm(), 500);
                        } else {
                            console.error("Error submitting missed event report.");
                            toast.error("Error submitting missed event report.");
                        }
                    }).catch(error => {
                        console.error("Error submitting missed event report:", error);
                        toast.error("Error submitting missed event report.");
                    });
                }}>
                <label className="form-label mt-2">From *</label>
                <input ref={fromDateRef} className="form-control" type="date" name="started_date" required
                    onChange={(e) => {
                        if (peakDateRef.current) {
                            peakDateRef.current.min = e.target.value;
                        }
                        if (toDateRef.current) {
                            toDateRef.current.min = e.target.value;
                        }
                    }}
                />
                <label className="form-label mt-2">To *</label>
                <input ref={toDateRef} className="form-control" type="date" name="ended_date" required
                    onChange={(e) => {
                        if (peakDateRef.current) {
                            peakDateRef.current.max = e.target.value;
                        }
                        if (fromDateRef.current) {
                            fromDateRef.current.max = e.target.value;
                        }
                    }}
                />
                <label className="form-label mt-4 fs-6">When did the peak flow occur *?</label>
                <input ref={peakDateRef} className="form-control" type="date" name="peak_date" required />
                <label className="form-label mt-4 fs-6">Where did the flood event happen?</label>
                {/* country, region/river basin, name of the river */}
                {/* <input required className="form-control mt-1" type="text" name="country" placeholder="Country *" /> */}
                <select required className="form-select mt-1" name="country">
                    <option value="">Select country *</option>
                    {countriesList && countriesList.map((country) => (
                        <option key={country.abbreviation} value={country.abbreviation}>{country.fullname}</option>
                    ))}
                </select>
                <input required className="form-control mt-1" type="text" name="region" placeholder="Region/River Basin *" />
                <input required className="form-control mt-1" type="text" name="rivername" placeholder="Name of the river *" />
                <input required className="form-control mt-1" type="text" placeholder="Coordinates" defaultValue={coordinates4326.toString()} />

                <label className="form-label mt-4 fs-6">What type of flood event took place? Please select all that apply *:</label>
                <div className="d-flex flex-column">
                    <div className="form-check">
                        <input type="checkbox" className="form-check-input" name="flood-event-1" value="flood-event-1" id="flood-event-1" />
                        <label className="form-check-label" htmlFor="flood-event-1">Flash flood</label>
                    </div>
                    <div className="form-check">
                        <input type="checkbox" className="form-check-input" name="flood-event-2" value="flood-event-2" id="flood-event-2" />
                        <label className="form-check-label" htmlFor="flood-event-2">River flood</label>
                    </div>
                    <div className="form-check">
                        <input type="checkbox" className="form-check-input" name="flood-event-3" value="flood-event-3" id="flood-event-3" />
                        <label className="form-check-label" htmlFor="flood-event-3">Urban flood</label>
                    </div>
                    <div className="form-check">
                        <input type="checkbox" className="form-check-input" name="flood-event-4" value="flood-event-4" id="flood-event-4" />
                        <label className="formcheck--label" htmlFor="flood-event-4">Coastal flood</label>
                    </div>
                </div>
                <label className="form-label mt-4 fs-6">What was the return period of the observed flood event *?</label>
                <select className="form-select" name="return_period" required>
                    <option value="">Select return period</option>
                    <option value="2-4">2-4 years</option>
                    <option value="5-9">5-9 years</option>
                    <option value="10-19">10-19 years</option>
                    <option value="20-99">20-99 years</option>
                    <option value=">=100">&gt;100 years</option>
                    <option value="not known">Not known</option>
                </select>

                <label className="form-label mt-4 fs-6">What was the impact of the flood event (water level above land, casualties, economic damage, evacuations, damage to infrastructure) *?</label>
                <textarea className="form-control" name="impact" rows={4} required></textarea>

                <label className="form-label mt-4 fs-6">What caused the flood event? (If more than one cause, please rank the alternatives.)</label>
                <ButtonGroupRanking name='causes' selectedCausesRef={selectedRef}
                    values={[
                        { name: "Snow Melting", value: 1, order: 1 },
                        { name: "Long-term raining", value: 2, order: 2 },
                        { name: "Extreme rainfall", value: 3, order: 3 },
                        { name: "Soil saturation", value: 4, order: 4 },
                        { name: "Ice jam", value: 5, order: 5 },
                        { name: "Dam break", value: 6, order: 6 },
                    ]} />
                <label className="form-label mt-4 fs-6">If none of these was the cause, what was the reason for the flood event?</label>
                <textarea className="form-control" name="other_flood_cause" rows={2}></textarea>
                <label className="form-label mt-4 fs-6">How much rain fell? (Example: 100 mm in 24 hours in Landshut, Germany - 12 June to 13 June 2018)</label>
                <input className="form-control" type="text" name="amount_rain" />
                <label className="form-label mt-4 fs-6">Was the flood event forecasted by the national institute / forecasting system *?</label>
                <select name="local_forecasted" className="form-select" required>
                    <option value="">Select an option</option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                </select>
                <label className="form-label mt-4 fs-6">Was there a national warning for this flood event *?</label>
                <select name="national_warning" className="form-select" required>
                    <option value="">Select an option</option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                </select>
                <label className="form-label mt-4 fs-6">Was the flood event reported in the media *?</label>
                <select name="flood_reported" className="form-select" required>
                    <option value="">Select an option</option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                </select>
                <label className="form-label mt-4 fs-6">Additional comments:</label>
                <textarea className="form-control" name="comments" rows={4}></textarea>
                <div className="d-flex justify-content-center mt-2">
                    <input type="submit" className="btn btn-primary px-4" value="Submit report" />
                    <input type="reset" className="btn btn-warning px-4 ms-2" value="Close without submitting" onClick={() => props.closeForm()} />
                </div>
            </form>
        </div>
    </div>;
}